export default __webpack_public_path__ + "static/enable-canvas-recording-in-replay-settings-2f6070738dc65c0f6d5707f9a2654338.png";